import { DATALAYER_EVENT } from '../../../../client/analytics/dataLayerConstants';
import { sendEvent } from '../../../../client/analytics/dataLayerService';
export function setupAppStoreButtonTracking() {
  var appStoreButtons = document.querySelectorAll('.old-app-store-button');
  appStoreButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      sendEvent(DATALAYER_EVENT.APP_STORE_LINK_CLICK);
    });
  });
}